import React from 'react';
import { BilingualText } from '../components/BilingualText';
import { CapacityCard } from '../components/CapacityCard';
import { ShipmentCard } from '../components/ShipmentCard';
import { LayoutDashboard, Calendar, Package, Settings, Bell, Search, Filter, Plus, BarChart3, Users, Warehouse, ClipboardCheck, Truck, Settings2, CheckCircle2, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export function Dashboard() {
  const {
    user
  } = useAuth();
  const isAdmin = user?.role === 'ADMIN';
  const isStaff = user?.role === 'STAFF';
  const isSupplier = user?.role === 'SUPPLIER';
  return <div className="min-h-screen bg-slate-50 pb-20 lg:pb-0" data-id="element-628">
      <main className="p-4 lg:p-8 max-w-7xl mx-auto space-y-8" data-id="element-629">
        {/* KPI Cards */}
        <section className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-630">
          {(isAdmin || isStaff) && <KpiCard label="Today's Appointments" value="18" sub="Appointments" icon={Calendar} color="text-blue-600" bgColor="bg-blue-50" data-id="element-631" />}
          {(isAdmin || isStaff) && <KpiCard label="Waiting Trucks" value="5" sub="Waiting" icon={Truck} color="text-orange-600" bgColor="bg-orange-50" data-id="element-632" />}
          {isSupplier && <KpiCard label="My Shipments" value="12" sub="Active" icon={Package} color="text-blue-600" bgColor="bg-blue-50" data-id="element-633" />}
          {isSupplier && <KpiCard label="Approved Slots" value="8" sub="Confirmed" icon={CheckCircle2} color="text-green-600" bgColor="bg-green-50" data-id="element-634" />}
          {(isAdmin || isStaff) && <KpiCard label="Goods Received" value="12" sub="Shipments" icon={CheckCircle2} color="text-green-600" bgColor="bg-green-50" data-id="element-635" />}
          {(isAdmin || isStaff) && <KpiCard label="Pending Approvals" value="7" sub="Pending" icon={Clock} color="text-indigo-600" bgColor="bg-indigo-50" data-id="element-636" />}
        </section>

        {/* Quick Actions */}
        <section className="space-y-4" data-id="element-637">
          <BilingualText en="Quick Actions" ar="إجراءات سريعة" className="text-lg" data-id="element-638" />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-639">
            {(isAdmin || isSupplier) && <Link to="/create" className="btn-primary py-4 h-auto flex-col items-start text-left px-6" data-id="element-640">
                <Plus size={24} className="mb-2" data-id="element-641" />
                <div className="font-bold text-lg text-white" data-id="element-642">
                  Create Shipment
                </div>
                <div className="text-xs text-white/80" data-id="element-643">
                  Generate new ASN and book slot
                </div>
              </Link>}
            {isAdmin && <Link to="/users" className="btn-secondary py-4 h-auto flex-col items-start text-left px-6 border-2 border-slate-100 hover:border-[#2E3192]/30" data-id="element-644">
                <Users size={24} className="mb-2 text-[#2E3192]" data-id="element-645" />
                <div className="font-bold text-lg text-slate-800" data-id="element-646">
                  Manage Users
                </div>
                <div className="text-xs text-slate-400" data-id="element-647">
                  Configure roles and permissions
                </div>
              </Link>}
            {(isAdmin || isStaff) && <Link to="/reports" className="btn-secondary py-4 h-auto flex-col items-start text-left px-6 border-2 border-slate-100 hover:border-[#2E3192]/30" data-id="element-648">
                <BarChart3 size={24} className="mb-2 text-[#2E3192]" data-id="element-649" />
                <div className="font-bold text-lg text-slate-800" data-id="element-650">
                  View Reports
                </div>
                <div className="text-xs text-slate-400" data-id="element-651">
                  Analytics and performance KPIs
                </div>
              </Link>}
            {isStaff && <Link to="/receiving" className="btn-primary py-4 h-auto flex-col items-start text-left px-6" data-id="element-652">
                <Truck size={24} className="mb-2" data-id="element-653" />
                <div className="font-bold text-lg text-white" data-id="element-654">
                  Start Receiving
                </div>
                <div className="text-xs text-white/80" data-id="element-655">
                  Process arriving trucks
                </div>
              </Link>}
          </div>
        </section>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-656">
          {/* Left Column: Appointments */}
          <div className="lg:col-span-2 space-y-4" data-id="element-657">
            <div className="flex items-center justify-between" data-id="element-658">
              <BilingualText en="Today's Schedule" ar="جدول اليوم" className="text-lg" data-id="element-659" />
              <div className="flex gap-2" data-id="element-660">
                <button className="p-2 bg-white border border-slate-200 rounded-lg text-slate-500" data-id="element-661">
                  <Search size={18} data-id="element-662" />
                </button>
                <button className="p-2 bg-white border border-slate-200 rounded-lg text-slate-500" data-id="element-663">
                  <Filter size={18} data-id="element-664" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-665">
              <ShipmentCard id="ASN-98231" supplierEn="Global Logistics Co." supplierAr="شركة الخدمات اللوجستية العالمية" status="Truck Arrived" time="09:30 AM" warehouseEn="Riyadh Main (WH-01)" warehouseAr="الرياض الرئيسي (WH-01)" data-id="element-666" />
              <ShipmentCard id="ASN-98235" supplierEn="FastTrack Trading" supplierAr="فاست تراك للتجارة" status="Check-in" time="10:15 AM" warehouseEn="Riyadh Main (WH-01)" warehouseAr="الرياض الرئيسي (WH-01)" data-id="element-667" />
              <ShipmentCard id="ASN-98240" supplierEn="Prime Goods Ltd" supplierAr="شركة برايم للسلع المحدودة" status="Unloading" time="11:00 AM" warehouseEn="Riyadh Main (WH-01)" warehouseAr="الرياض الرئيسي (WH-01)" data-id="element-668" />
              <ShipmentCard id="ASN-98244" supplierEn="Al-Futtaim Group" supplierAr="مجموعة الفطيم" status="Confirmed" time="01:30 PM" warehouseEn="Riyadh Main (WH-01)" warehouseAr="الرياض الرئيسي (WH-01)" data-id="element-669" />
            </div>

            <Link to="/appointments" className="block w-full py-3 text-center text-sm font-bold text-[#2E3192] bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors" data-id="element-670">
              View All Appointments
            </Link>
          </div>

          {/* Right Column: Capacity & Notifications */}
          <div className="space-y-8" data-id="element-671">
            {/* Capacity Overview */}
            <section className="space-y-4" data-id="element-672">
              <div className="flex items-center justify-between" data-id="element-673">
                <BilingualText en="Capacity Overview" ar="نظرة عامة على السعة" className="text-lg" data-id="element-674" />
                <Link to="/settings" className="text-[#2E3192] text-xs font-bold" data-id="element-675">
                  Manage
                </Link>
              </div>
              <div className="space-y-4" data-id="element-676">
                <CapacityCard labelEn="Shipments" labelAr="الشحنات" current={42} total={50} unitEn="Shipments" unitAr="شحنة" data-id="element-677" />
                <CapacityCard labelEn="Cartons" labelAr="الكراتين" current={1850} total={2500} unitEn="Cartons" unitAr="كرتون" data-id="element-678" />
              </div>
            </section>

            {/* Notifications Widget */}
            <section className="space-y-4" data-id="element-679">
              <BilingualText en="Recent Alerts" ar="تنبيهات حديثة" className="text-lg" data-id="element-680" />
              <div className="card divide-y divide-slate-50" data-id="element-681">
                <NotificationItem title="Capacity Reached 90%" time="10 mins ago" type="alert" data-id="element-682" />
                <NotificationItem title="Truck Arrived: ASN-98231" time="25 mins ago" type="info" data-id="element-683" />
                <NotificationItem title="Appointment Approved" time="1 hour ago" type="success" data-id="element-684" />
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>;
}
function KpiCard({
  label,
  value,
  sub,
  icon: Icon,
  color,
  bgColor
}: any) {
  return <div className="card p-4 flex flex-col gap-3 hover:shadow-md transition-all cursor-pointer group" data-id="element-685">
      <div className={`w-10 h-10 rounded-lg ${bgColor} ${color} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-686">
        <Icon size={20} data-id="element-687" />
      </div>
      <div data-id="element-688">
        <div className="text-2xl font-bold text-slate-800" data-id="element-689">{value}</div>
        <div className="text-[10px] text-slate-400 font-bold uppercase tracking-wider" data-id="element-690">
          {label}
        </div>
      </div>
    </div>;
}
function NotificationItem({
  title,
  time,
  type
}: any) {
  const colors = {
    alert: 'bg-red-500',
    info: 'bg-blue-500',
    success: 'bg-green-500'
  };
  return <div className="p-4 flex items-start gap-3 hover:bg-slate-50 transition-colors cursor-pointer" data-id="element-691">
      <div className={`w-2 h-2 rounded-full mt-1.5 ${colors[type as keyof typeof colors]}`} data-id="element-692" />
      <div data-id="element-693">
        <div className="text-sm font-bold text-slate-700" data-id="element-694">{title}</div>
        <div className="text-[10px] text-slate-400 font-medium" data-id="element-695">{time}</div>
      </div>
    </div>;
}